import { useCallback, useRef, useState } from 'react';
import { useConnectedTurnaround } from '@connect-x-app/hybrid-state';

import { ConnectedTurnaroundPanel } from './components/connectedTurnaroundPanel/ConnectedTurnaroundPanel';
import { LauncherButton } from './components/launcherButton/LauncherButton';

const ADMIN_AGENT = 'otp';

export const ConnectedTurnaroundChat = () => {
  const conversation = useConnectedTurnaround(ADMIN_AGENT);
  const launcherRef = useRef<HTMLButtonElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [draft, setDraft] = useState('');

  const togglePanel = useCallback(() => setIsOpen(wasOpen => !wasOpen), []);

  const closePanel = useCallback(() => {
    setIsOpen(false);
    launcherRef.current?.focus();
  }, []);

  return (
    <>
      {isOpen ? <ConnectedTurnaroundPanel {...conversation} draft={draft} onClose={closePanel} onDraftChange={setDraft} /> : null}
      <LauncherButton isOpen={isOpen} onClick={togglePanel} ref={launcherRef} />
    </>
  );
};
